import { render } from "./board.vue?vue&type=template&id=4585108b&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"

import "./board.vue?vue&type=style&index=0&id=4585108b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4585108b"

export default script